import React from 'react';

interface Props {
  currentStep: number;
}

export const LayoutStyles = ({ currentStep }: Props) => {
  let imageSet: string;
  if (currentStep === 0) {
    imageSet = 'default';
  } else if (currentStep === 1) {
    imageSet = 'step1';
  } else if (currentStep === 2) {
    imageSet = 'step2';
  } else {
    imageSet = 'default';
  }

  return (
    <React.Fragment>
      <div className="absolute inset-0 z-[2] pointer-events-none overflow-hidden">
        <div className="absolute left-0 top-0 right-0 h-14 bg-[#5B73F14D]" />
        <div className="absolute left-0 bottom-0 right-0 h-14 bg-[#5B73F14D]" />
        <div className="absolute left-0 top-14 bottom-14 w-14 bg-[#5B73F14D]" />
        <div className="absolute right-0 top-14 bottom-14 w-14 bg-[#5B73F14D]" />
      </div>
      {imageSet === 'default' && (
        <>
          <div className="absolute top-1/3 left-0 max-w-[9.02188rem] max-h-[10.02188rem] z-[1]">
            <img src="/images/signin-circle.svg" alt="Circle" className="size-full" draggable={false} />
          </div>
          <div className="absolute left-0 bottom-0 max-w-[10.02106rem] max-h-[25.10988rem] z-[1]">
            <img src="/images/signin-rectangle-1.svg" alt="Rectangle" className="size-full" draggable={false} />
          </div>
          <div className="absolute left-14 bottom-14 size-[4.75rem] z-[2] bg-[#5B73F14D]" />
          <div className="absolute left-14 bottom-14 max-w-[10.02106rem] max-h-[25.10988rem] z-[2] rounded-bl-[6rem] overflow-hidden">
            <img src="/images/signin-rectangle-2.svg" alt="Rectangle" className="size-full" draggable={false} />
          </div>
          <div className="absolute top-0 right-0 max-w-[15.69825rem] max-h-[22.53969rem] z-[3]">
            <img src="/images/signin-triangle.svg" alt="Triangle" className="size-full" draggable={false} />
          </div>
        </>
      )}
      {imageSet === 'step1' && (
        <>
          <div className="absolute top-0 max-w-[11rem] max-h-[11rem] -translate-x-1/2 left-1/2 z-[1]">
            <img src="/images/returning-signin-circle-2.svg" alt="Circle" className="size-full" draggable={false} />
          </div>
          <div className="absolute left-0 bottom-0 max-w-[19.3125rem] max-h-[33rem] z-[1] opacity-60">
            <img src="/images/returning-signin-l-1.svg" alt="L Shape" className="size-full" draggable={false} />
          </div>
          <div className="absolute left-14 bottom-14 max-w-[19.3125rem] max-h-[33rem] z-[1] rounded-bl-[6rem] overflow-hidden">
            <img src="/images/returning-signin-l-2.svg" alt="L Shape" className="size-full" draggable={false} />
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-0 max-w-[18.5rem] max-h-[26.5625rem] z-[3]">
            <img src="/images/returning-signin-triangle-1.svg" alt="Triangle" className="size-full" draggable={false} />
          </div>
        </>
      )}
      {imageSet === 'step2' && (
        <>
          <div className="absolute left-0 bottom-0 max-w-[32.125rem] max-h-[32.125rem] z-[1]">
            <img src="/images/returning-signin-circle-3.svg" alt="Circle" className="size-full" draggable={false} />
          </div>
          <div className="absolute left-14 bottom-14 size-24 z-[2] bg-[#5B73F14D]" />
          <div className="absolute left-14 bottom-14 max-w-[32.125rem] max-h-[32.125rem] z-[2] rounded-bl-[6rem] overflow-hidden">
            <img src="/images/returning-signin-circle-5.svg" alt="Circle" className="size-full" draggable={false} />
          </div>
          <div className="absolute top-0 right-0 max-w-[18.5rem] max-h-[26.5625rem] z-[3]">
            <img src="/images/returning-signin-triangle-2.svg" alt="Triangle" className="size-full" draggable={false} />
          </div>
        </>
      )}
    </React.Fragment>
  );
};
